// Estilos de los íconos (src/components/FontAwesomeIcon). Solo el CSS: el JavaScript del núcleo
// de Font Awesome ya no se usa.
import '@fortawesome/fontawesome-svg-core/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { mountApp } from './utilities/prerender-handoff';

'scrollRestoration' in window.history &&
    (window.history.scrollRestoration = 'manual');

// En páginas prerenderizadas el HTML se ve de inmediato y la app lo releva al estar lista
// (src/utilities/prerender-handoff.js); en las demás se monta directamente en #root.
mountApp(container => ReactDOM.createRoot(container).render(<App />));
